<template>
  <div>
    <!-- Header -->
    <header
      class="border-b border-gray-200 dark:border-gray-800 bg-white/80 dark:bg-gray-900/80 backdrop-blur supports-[backdrop-filter]:bg-white/60 sticky top-0 z-30"
    >
      <div class="container flex items-center justify-between py-4">
        <div class="flex items-center gap-3">
          <div
            class="h-8 w-8 rounded-md bg-brand-500 flex items-center justify-center shadow-soft"
          >
            <span class="material-symbols-rounded text-white text-[18px]">
              shield_person
            </span>
          </div>
          <RouterLink
            to="/dashboard"
            class="font-extrabold tracking-tight text-xl"
          >
            Access System
          </RouterLink>
        </div>

        <nav class="flex items-center gap-3">
          <button v-if="auth.isAdmin" class="btn" @click="onSignOut">
            <span class="material-symbols-rounded">logout</span>
            <span class="hidden sm:inline">Sign out</span>
          </button>
        </nav>
      </div>
    </header>

    <!-- Main -->
    <main class="container py-6">
      <RouterView />
    </main>

    <!-- Footer -->
    <footer class="container py-10 text-xs text-gray-500">
      <div class="border-t border-gray-200 dark:border-gray-800 pt-6">
        <div class="flex items-center justify-between">
          <div>© {{ year }} CPG Radar</div>
          <div class="flex items-center gap-4">

          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { RouterLink, RouterView, useRouter } from 'vue-router'
import { useAuthStore } from './main'

const router = useRouter()
const auth = useAuthStore()

const year = computed(() => new Date().getFullYear())

const onSignOut = async () => {
  await auth.signOut()
  auth.setAdminSecret('')
  router.replace({ path: '/login' })
}
</script>
